import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import axios from 'axios'
import { subtotalStore } from '@/stores/v2/subtotal'
import { CompletionOneRoomGroup } from '@/types/v2/completion1/completionOneRoomGroup'
import { headerStore } from '@/stores/header'

export const completion1Store = defineStore('v2/completion1', () => {
  const loading = ref(false)
  const saving = computed(() => savingRoomId.value > 0)
  const savingRoomId = ref(0)
  const phaseState = ref('loading')
  const phaseClosed = computed(() => ['closed', 'processed', 'expired'].includes(phaseState.value) || headerStore().ordersReceived.completion)

  const roomGroups = ref<CompletionOneRoomGroup[]>([])

  function getCompletion1Products () : void {
    loading.value = true
    axios.get(process.env.VUE_APP_API_URL_V2 + '/completion1').then((r) => {
      roomGroups.value = r.data
    }).finally(() => {
      loading.value = false
    })
  }

  function toggleProduct (id:number) : void {
    savingRoomId.value = id
    axios.post(process.env.VUE_APP_API_URL_V2 + '/completion1/' + id).then((r) => {
      roomGroups.value = r.data
    }).finally(() => {
      subtotalStore().getSubtotals()
      savingRoomId.value = 0
    })
  }

  function getPhaseState () : void {
    axios.get(process.env.VUE_APP_API_URL + '/phase/2/closed').then((r) => {
      phaseState.value = r.data.status
    })
  }

  return {
    loading,
    saving,
    savingRoomId,
    phaseState,
    phaseClosed,
    roomGroups,
    getCompletion1Products,
    toggleProduct,
    getPhaseState
  }
})
